import { Flex } from "antd";

export const ContainerComponent = ({
  children,
  style,
  className,
  ...props
}) => {
  return (
    <Flex
      vertical
      style={{
        ...style,
      }}
      className={className}
      {...props}
    >
      {children}
    </Flex>
  );
};
